import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getHotelQueryOptions, getHotelsQueryOptions } from "./get.hooks";

export function useDeleteHotel(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/hotels/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getHotelsQueryOptions.queryKey, (old) =>
        old?.filter((h) => h.id !== id),
      );
      queryClient.resetQueries({ queryKey: getHotelQueryOptions(id).queryKey });
      toast({
        title: "toast.hotelDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteHotelError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
